import React from 'react';
import {withRouter} from "react-router";
import {Link} from 'react-router-dom';

import {Button} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import ReCAPTCHA from "react-google-recaptcha";

import API from "@beardeddevops/react.api";
import APPCONFIG from 'constants/Config';
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";

/**
 *  @property {Accounts_Object} state
 *  @property {object} model
 *  @property {Accounts_Properties} model.properties
 *  @property {Accounts_Is} model.is
 *  @property {Accounts_Has} model.has
 */
class Login extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Admins._name);
		this.model.requestType = API.RequestType.READ;
		this.recaptchaRef = React.createRef();
		this.brand = APPCONFIG.brand;
		this.shouldAutoLoad = false;
	}

	handleSubmit = async event => {
		if (typeof event !== 'undefined') event.preventDefault();
		if (process.env.production) {
			this.state.g_recaptcha_response = this.recaptchaRef.current.getValue();
			if (!this.state.g_recaptcha_response) {
				return false;
			}
		}
		this.setState({loading: true});
		if (this.handleProcess(null, API.RequestType.READ)) {
			try {
				await this.model.submit(this, API.RequestType.READ, false, false, false, true);
				this.props.history.push('/dashboard');
			} catch (e) {
				this.setState({loading: false});
			}
		} else {
			this.setState({loading: false});
		}
		return false;
	};

	onChange = value => {
		console.log("Captcha value:", value);
	};

	// noinspection JSMethodCanBeStatic
	onExpired(value) {
		console.log("Captcha value:", value);
	}

	render() {
		let {properties} = this.model;
		let object = this.state;
		let brand = this.brand;
		return (
			<div className="body-inner">
				<Card>
					<CardContent style={{paddingBottom: 0}}>
						<section className="logo text-center">
							<h1>{brand} Admin</h1>
						</section>

						<fieldset>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.email}
									error={object.email_error}
									property={properties.email}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
								/>
							</div>
							<br/>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.password}
									error={object.password_error}
									property={properties.password}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
									type={"password"}
								/>
							</div>
							<br/>
						</fieldset>
						{process.env.production &&
						<div style={{textAlign: 'center', paddingTop: '10px'}}>
							<ReCAPTCHA
								ref={this.recaptchaRef}
								sitekey={APPCONFIG.reCAPTCHA}
								onChange={this.onChange}
								onExpired={this.onExpired.bind(this)}
								style={{
									display: 'inline-block'
								}}
							/>
						</div>}

					</CardContent>
					<CardActions>
						<Button onClick={this.handleSubmit} type={"submit"} id={"button-login"} color="primary" size={"md"}
						        block={false}>Login</Button>
					</CardActions>
				</Card>
				<div className="additional-info">
					<span style={{'color': '#909090'}}>Version {process.env.version} | {APPCONFIG.copyright}-{APPCONFIG.year} © <a className="brand" target="_blank" href={APPCONFIG.productLink} style={{'color': '#525252'}}>{APPCONFIG.brand}</a></span><br />
				</div>

			</div>
		);
	}
}

const LoginRoute = withRouter(Login);
const Page = () => (
	<div className="page-login">
		<div className="main-body">
			<div key="1">
				<LoginRoute/>
			</div>
		</div>
	</div>
);

export default Page;